import React from "react";

const Tickets = () => {
  return <div className="w-full">Tickets</div>;
};

export default Tickets;
